import { defineComponent as _defineComponent } from 'vue'
import { AccountApi } from '@/openapi';
import { ref } from 'vue';
import store from '@/store';
import { useRouter } from 'vue-router/composables';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const accountApi = new AccountApi(undefined, '');
const router = useRouter();
const activeItem = ref('/');

const logout = async () => {
    accountApi.logout().then(() => {
        store.commit('setLoggedOut');
        router.push({ path: '/login' });
    });
};

return { __sfc: true,accountApi, router, activeItem, logout }
}

})